"use client";

import { useEffect, useRef } from "react";

export function ReadingProgress() {
  const barRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const art = document.querySelector<HTMLElement>("[data-prose]");
    const bar = barRef.current;
    if (!art || !bar) return;

    let ticking = false;
    const update = () => {
      const rect = art.getBoundingClientRect();
      const total = rect.height - window.innerHeight * 0.5;
      const progress = Math.min(1, Math.max(0, -rect.top / (total || 1)));
      bar.style.width = `${(progress * 100).toFixed(1)}%`;
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };

    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return (
    <div className="progress" aria-hidden="true">
      <span ref={barRef} data-progress />
    </div>
  );
}
